import { type ChainFullId, type UnifiedTokenBalance } from "@umami/chains";
import { useDynamicModalContext } from "@umami/components";
import { useCurrentAccount, useGetChainBalance, useGetTotalBalance } from "@umami/state";
import { isMultichainEnabled } from "@umami/utils";

import { ArrowUpRightIcon } from "../../assets/icons";
import { ChainSelectModal } from "../ChainSelectModal";
import { IconButtonWithText } from "../IconButtonWithText/IconButtonWithText";
import { InsufficientFunds } from "../SendFlow/InsufficientFunds/InsufficientFunds";
import { FormPage as TezFormPage } from "../SendFlow/Tez/FormPage";
import { FormPage as MultiChainFormPage } from "../SendFlow/Token/FormPage";

export const SendButton = () => {
  const { openWith } = useDynamicModalContext();

  const currentAccount = useCurrentAccount()!;

  const { hasAssets } = useGetTotalBalance();
  const getChainBalance = useGetChainBalance();

  const handleChainSelect = async (chainId: ChainFullId, token?: UnifiedTokenBalance) => {
    const { balance } = getChainBalance(chainId);

    if (!Number(balance)) {
      return await openWith(<InsufficientFunds chainId={chainId} />);
    }

    if (token) {
      await openWith(
        <MultiChainFormPage chainId={chainId} sender={currentAccount} token={token} />
      );
    } else {
      await openWith(<TezFormPage chainId={chainId} sender={currentAccount} />);
    }
  };

  const handleClick = async () => {
    if (!hasAssets) {
      await openWith(<InsufficientFunds />);
    } else if (isMultichainEnabled()) {
      await openWith(<ChainSelectModal onClick={handleChainSelect} />);
    } else {
      await openWith(<TezFormPage sender={currentAccount} />);
    }
  };

  return (
    <IconButtonWithText
      data-testid="send-button-account-card"
      icon={ArrowUpRightIcon}
      label="Send"
      onClick={handleClick}
      variant="primary"
    />
  );
};
